$(document).ready(function(){
	$(".modal_btn").length  !== 0 ? triggerEvt.modalTrigger() : undefined;
    $(".scr_up").length     !== 0 ? triggerEvt.scrUpTrigger() : undefined;
    $(".scr_down").length   !== 0 ? triggerEvt.scrDownTrigger() : undefined;
    $(".menu_wrap").length  !== 0 ? triggerEvt.hambugerTrigger() : undefined;
});

const triggerEvt = {
	modalTrigger: ()=>{
		const modalBtns = $(".modal_btn");
		modalBtns.on('click', function(){ commonJS.modalEvt($(this)); });
	},
    scrUpTrigger: ()=>{
        const scrBtn = $(".scr_up");
        scrBtn.on('click', function(){ commonJS.scrollTopEvt(); });
    },
    scrDownTrigger: ()=>{
        const scrBtn = $(".scr_down");
        scrBtn.on('click', function(){ commonJS.scrollDownEvt(); });
    },
    hambugerTrigger: ()=>{
        const menuBtn = $(".menu_btn");
        menuBtn.on('click', function(){ commonJS.hambugerMenuEvt($(this)); });
    }
};

const commonJS = {
	modalEvt: (th)=>{
		const modals = $(".modal");
		let name = $(th).data("modal");
		
		th.hasClass("close_modal") ? closeModal(name) : openModal(name);
		
		function openModal(name){
			modals.removeClass("show");
			$(`#${name}`).addClass("show");

            if(th.hasClass("video_btn")){
                $("#st_video")[0].currentTime = 0;
            }else return false;
		}

		function closeModal(name){
			$(`#${name}`).removeClass("show");

            if(th.hasClass("video_btn")){
                $("#st_video")[0].pause();
            }else return false;
		}
	},
    scrollTopEvt: function(){
        $("html, body").animate({
            scrollTop: 0
        }, 500)
    },
    scrollDownEvt: function(){
        $("html, body").animate({
            scrollTop: $(".scr_down_trigger").offset().top
        }, 500)
    },
    hambugerMenuEvt: function(th){
        if(th.hasClass("open")){
            $(".menu_wrap").addClass("show");
            $("body").addClass("scrollLock");
        }else{
            $(".menu_wrap").removeClass("show");
            $("body").removeClass("scrollLock");
        }
    }
}